export default __webpack_public_path__ + "static/media/anuj.9c7d1b76.jpg";